import React from "react";

const SvgLayers = props => (

<svg fill="#000000" version="1.1" id="Layer_1"
	 x="0px" y="0px" viewBox="0 0 512 512" style={{width: "1.5em", height: "1.5em"}} {...props}>
<g>
	<g>
		<path d="M500.883,343.939l-63.441-34.607l63.44-34.604c14.823-8.086,14.824-29.371,0.001-37.457l-63.441-34.606l63.44-34.604
			c14.824-8.086,14.824-29.371,0-37.457l-234.667-128c-6.368-3.473-14.063-3.473-20.431,0l-234.667,128
			c-14.824,8.086-14.824,29.371,0,37.457l63.44,34.604l-63.441,34.606c-14.823,8.086-14.823,29.371,0.001,37.457l63.44,34.604
			l-63.441,34.607c-14.823,8.086-14.823,29.371,0.001,37.457l234.667,128c6.368,3.473,14.063,3.473,20.431,0l234.667-128
			C515.706,373.31,515.706,352.025,500.883,343.939z M256,45.634l190.116,103.699L256,253.033L65.884,149.333L256,45.634z
			 M119.105,226.967l126.68,69.095c0.374,0.204,0.753,0.393,1.135,0.573c0.025,0.012,0.049,0.026,0.074,0.037
			c0.176,0.082,0.356,0.152,0.534,0.229c0.311,0.135,0.622,0.265,0.938,0.384c0.696,0.263,1.402,0.489,2.117,0.677
			c0.062,0.016,0.124,0.038,0.186,0.053c1.243,0.315,2.509,0.511,3.78,0.598c0.967,0.066,1.938,0.066,2.905,0
			c1.271-0.087,2.536-0.284,3.78-0.598c0.063-0.016,0.124-0.037,0.186-0.053c0.714-0.188,1.42-0.414,2.117-0.677
			c0.315-0.119,0.627-0.25,0.938-0.384c0.178-0.077,0.358-0.146,0.534-0.229c0.025-0.012,0.049-0.026,0.074-0.037
			c0.382-0.18,0.761-0.369,1.135-0.573l126.68-69.095l53.222,29.032L256,359.699l-190.117-103.7L119.105,226.967z M256,466.366
			l-190.117-103.7l53.222-29.032l126.68,69.095c0.374,0.204,0.753,0.393,1.135,0.573c0.025,0.012,0.049,0.026,0.074,0.037
			c0.176,0.082,0.356,0.152,0.534,0.229c0.311,0.135,0.622,0.265,0.938,0.384c0.696,0.263,1.402,0.489,2.117,0.677
			c0.062,0.016,0.124,0.038,0.186,0.053c0.066,0.017,0.133,0.028,0.199,0.044c3.307,0.803,6.76,0.803,10.067,0
			c0.066-0.016,0.133-0.027,0.199-0.044c0.063-0.016,0.124-0.037,0.186-0.053c0.714-0.188,1.42-0.414,2.117-0.677
			c0.315-0.119,0.627-0.25,0.938-0.384c0.178-0.077,0.358-0.146,0.534-0.229c0.025-0.012,0.049-0.026,0.074-0.037
			c0.382-0.18,0.761-0.369,1.135-0.573l126.68-69.095l53.222,29.032L256,466.366z"/>
	</g>
</g>

</svg>
);

export default SvgLayers;